import { useSearchParams } from "react-router";
import { useForm } from "react-hook-form";
import { useServiceTypes } from "@/api/get-service-types";
import { useProfessions } from "@/api/get-professions";
import { SearchForm } from "./clinician-list-search-form";

export const ClinicianListSearch = () => {
    // Get Service Types
    const { data: serviceTypes } = useServiceTypes();

    // Get Professions
    const { data: professions } = useProfessions();

    // Get form values from URL
    let [searchParams, setSearchParams] = useSearchParams();

    const filters = {
        serviceSearch: searchParams.get("serviceType")
            ? searchParams.get("serviceType").split(",")
            : [],
    };

    // Filter clinicians
    const methods = useForm({
        values: filters,
    });

    const filterClinicians = (data) => {
        setSearchParams((params) => {
            if (data.serviceSearch?.length) {
                params.set("serviceType", data.serviceSearch.join(","));
            } else {
                params.delete("serviceType");
            }

            return params;
        });
    };

    return (
        <div className="container mx-auto">
            <SearchForm
                methods={methods}
                onSubmit={filterClinicians}
                serviceTypes={serviceTypes}
                professions={professions}
            />
        </div>
    );
};
